import { gql } from "@apollo/client";

export const GET_STUDENT_BY_STATUS_REPORT = gql`
  query GetStudentByStatusReport($status: String) {
    getStudentByStatusReport(status: $status) {
      _id
      classId {
        _id
        className
        courseId {
          _id
          enName
          khName
        }
      }
      studentId {
        _id
        profile
        studentId
        familyName
        studentName
        gender
        dob
        phoneNumber
        email
        nationlity
        address
        startHourDate
        totalHour
        totalHourRemain
      }
      startSchoolDate
      totalHour
      totalRemainHour
      status
      totalStudent
      remark
    }
  }
`;

export const GET_INVOICE_REPORT = gql`
  query GetInvoiceReport(
    $fromDate: String
    $toDate: String
    $paymentStatus: String
    $groupFeeType: String
  ) {
    getInvoiceReport(
      fromDate: $fromDate
      toDate: $toDate
      paymentStatus: $paymentStatus
      groupFeeType: $groupFeeType
    ) {
      totalByDirectClass
      totalByOnlineClass
      totalByBook
      totalByInstrument
      totalAmount
      invoiceData {
        _id
        date
        invoiceNumber
        invoiceType
        paymentStatus
        remark
        totalAmount
        totalReceived
        totalOwe
        void
        studentId {
          _id
          dob
          gender
          familyName
          studentName
          studentId
        }
      }
    }
  }
`;

export const GET_ALERT_TOPAY_INVOICE_REPORT = gql`
  query GetAlertToPayInvoiceReport($fromDate: String, $toDate: String) {
    getAlertToPayInvoiceReport(fromDate: $fromDate, toDate: $toDate) {
      _id
      date
      invoiceNumber
      invoiceType
      paymentStatus
      alertDates
      remark
      totalAmount
      totalReceived
      totalOwe
      void
      studentId {
        _id
        dob
        gender
        familyName
        studentName
        studentId
      }
    }
  }
`;

export const GET_PERFORMANCE_REPORT = gql`
  query GetPerformanceReport($classId: String, $performanceTypeId: String) {
    getPerformanceReport(
      classId: $classId
      performanceTypeId: $performanceTypeId
    ) {
      _id
      description
      performanceTypeId {
        _id
        khName
        enName
        date
        remark
      }
      studentId {
        _id
        familyName
        studentName
        gender
      }
      classId {
        _id
        className
        courseId {
          _id
          enName
        }
      }
      subjectId {
        _id
        khName
        enName
        remark
      }
    }
  }
`;

export const GET_EXPENSE_REPORT = gql`
  query GetExpenseReport($fromDate: String, $toDate: String, $type: String) {
    getExpenseReport(fromDate: $fromDate, toDate: $toDate, type: $type) {
      _id
      type {
        _id
        engType
        khType
        remark
      }
      date
      exchangeRate
      amountUSD
      amountKHR
      remark
    }
  }
`;
